$(document).ready(
    function () {

        $(document).on("submit", "#admin_organizer_search_form", function () {

            $.ajax({
                type: 'POST',
                url: "/ajax/admin_organizers/search",
                data: {
                    serialized_post: $(this).serialize()
                }
            })
                .done(function (data) {

                    if (data.html !== undefined && data.html !== null) {
                        $("#admin-organizer-list").remove();
                        $(".pagination").remove();
                        $("#admin-organizer-list-search").after(data.html);
                    }

                })
                .fail(function (data) {

                    if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                        document.location.href = data.responseJSON.redirect_url;
                    }

                });

            return false;

        });

    }
);